export const ENV = process.env.REACT_APP_ENV; 

const baseUrl = {
  PROD: 'https://api.learnify.ing',
  UAT: 'https://api-stage.learnify.ing',
  QA: '',
  DEV: 'http://localhost:3002',
};

export const getBaseUrl = () => {
  return baseUrl[ENV] ?? null;
};
